import { EventDrilldown } from "@/shared/model/event";
import { RemoveOthers } from "@/api/interfaces/common";
import { get as _get, isEmpty as _isEmpty, uniq as _uniq } from "lodash";

export const createIdMap = <T extends EventDrilldown>(
    groupedEvents: { [sportId: string]: T[] },
    idKey: string,
    type: "eventIds" | "leagueIds" = "eventIds",
): RemoveOthers => {
    if (_isEmpty(groupedEvents)) return {};
    return Object.keys(groupedEvents).reduce((obj, key) => {
        obj[key] = { [type]: _uniq(groupedEvents[key].map((e) => _get(e, idKey))) };
        return obj;
    }, {});
};

export const excludeIdsFromIdMap = (
    idMap: RemoveOthers,
    ids: string[],
    type: "eventIds" | "leagueIds" = "eventIds",
): RemoveOthers => {
    if (_isEmpty(idMap)) return {};
    return Object.keys(idMap).reduce((acc, key) => {
        const newIds = idMap[key]?.[type]?.filter((id) => !ids.includes(id));
        if (newIds?.length) acc[key] = { [type]: newIds };
        return acc;
    }, {});
};

export const excludeOtherTypeIdsFromIdMap = (
    idMap: RemoveOthers,
    type: "eventIds" | "leagueIds" = "eventIds",
): RemoveOthers => {
    if (_isEmpty(idMap)) return {};
    return Object.keys(idMap).reduce((acc, key) => {
        const newIds = idMap[key]?.[type];
        if (newIds?.length) acc[key] = { [type]: newIds };
        return acc;
    }, {});
};

export const getSportIdsFromIdMap = (idMap: RemoveOthers): string[] => (_isEmpty(idMap) ? [] : Object.keys(idMap));

export const getIdsByTypeFromIdMap = (
    idMap: RemoveOthers,
    type: "eventIds" | "leagueIds" = "eventIds",
): { [sportId: string]: string[] } =>
    _isEmpty(idMap)
        ? {}
        : Object.keys(idMap).reduce((acc, key) => {
              acc[key] = idMap[key]?.[type];
              return acc;
          }, {});

export const getIdsFromIdMap = (idMap: RemoveOthers, type: "eventIds" | "leagueIds" = "eventIds"): string[] =>
    _isEmpty(idMap) ? [] : Object.values(idMap).reduce((acc, values) => [...acc, ...(values?.[type] || [])], []);
